<app-header></app-header>

<app-subheader *ngIf="showSubHeader"></app-subheader>

<div class="container-fluid m-0" style="background-color: #F9F9F9">
  <router-outlet></router-outlet>
</div>

<app-footer></app-footer>

<app-loading></app-loading>
